import React from 'react';
import c from 'classnames';
import ModalHeadingText from '../ModalHeadingText';
import ModalSubText from '../ModalSubText';
import s from './ModalHeader.scss';
/**
 * The top portion of a modal. It has a heading and -- optionally -- a subheading and right-side slot.
 */ const ModalHeader = ({ heading, subheading, left, right, className })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, left && /*#__PURE__*/ React.createElement("div", {
        className: s['left']
    }, left), /*#__PURE__*/ React.createElement("div", {
        className: s['heading-and-subheading-block']
    }, /*#__PURE__*/ React.createElement(ModalHeadingText, null, heading), subheading && /*#__PURE__*/ React.createElement(ModalSubText, null, subheading)), /*#__PURE__*/ React.createElement("div", {
        className: s['right']
    }, right));
};
ModalHeader.displayName = 'ModalHeader';
export default ModalHeader;
